import { Checkbox } from 'antd';
import { StyledCardSelector } from './CardSelector.styled';

export default function CardSelector({ isSelected, onAdd, onRemove }) {
  return (
    <StyledCardSelector>
      <div
        className={`selector ${isSelected ? 'selected' : ''}`}
        onClick={() => {
          isSelected ? onRemove() : onAdd();
        }}
      >
        <Checkbox danger checked={isSelected} />
      </div>
    </StyledCardSelector>
  );
}
